module.exports = __webpack_public_path__ + "new-landing-hero-6776bd0a9332a9be59cfe95070c59cde.gif";